/**
 * A mark per reading.
 *
 * Beside the labels in the sidebar, and on its own in a rail; the loop map
 * draws the same marks so that a screen looks the same in both places. Keyed
 * off `LOOP` rather than written out, so a reading added there with no icon is
 * a compile error rather than a blank row.
 */

import {
	ArrowDownToLine,
	CalendarDays,
	Compass,
	FolderTree,
	Layers,
	LayoutTemplate,
	LineChart,
	MessageSquare,
	PenLine,
	Quote,
	Radar,
	ScanEye,
	Send,
	ShieldCheck,
	Split,
	Target,
	UserRound,
	Users,
} from "lucide-react";
import type { ReactNode } from "react";
import type { ReadingSlug } from "~/modules/analytics/lib/loop";

export const READING_ICONS: Record<ReadingSlug, ReactNode> = {
	visibility: <Target />,
	prompts: <MessageSquare />,
	fanouts: <Split />,
	platforms: <Layers />,
	personas: <UserRound />,
	citations: <Quote />,
	competitors: <Users />,
	sentiment: <ScanEye />,
	factcheck: <ShieldCheck />,
	opportunities: <Compass />,
	write: <PenLine />,
	templates: <LayoutTemplate />,
	distribution: <CalendarDays />,
	progress: <Send />,
	// The step before every number in stage 1: whether an engine ever came to
	// read what was published.
	crawlers: <Radar />,
	publications: <LineChart />,
	referrals: <ArrowDownToLine />,
};

/** The content tree's row, outside the numbered stages. */
export const CONTENT_ICON = <FolderTree />;
